import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4e83474e&lang=less&scoped=true"

import exportComponent from "/home/wau-sz006/前端项目/官网/voyager_V1.1.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e83474e"]])

export default __exports__